// API Configuration
// This file centralizes all API endpoints and configurations

const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Use environment variables for API URLs
// In production, these should be set in your deployment environment
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (isProduction 
    ? 'https://api.bizprop.com/api/bizprop' // Update this with your production URL
    : 'https://dev.northroom.co.za/api/bizprop');

export const apiConfig = {
  baseUrl: API_BASE_URL,
  endpoints: {
    auth: {
      adminLogin: `${API_BASE_URL}/users/admin/login`,
      forgotPassword: `${API_BASE_URL}/users/forgot-password`,
      resetPassword: `${API_BASE_URL}/users/reset-password`,
    },
    users: {
      list: `${API_BASE_URL}/users`,
      create: `${API_BASE_URL}/users`,
      update: (id: string) => `${API_BASE_URL}/users/${id}`,
      delete: (id: string) => `${API_BASE_URL}/users/${id}`,
    },
    properties: {
      list: `${API_BASE_URL}/properties`,
      create: `${API_BASE_URL}/properties`,
      update: (id: string) => `${API_BASE_URL}/properties/${id}`,
      delete: (id: string) => `${API_BASE_URL}/properties/${id}`,
      details: (id: string) => `${API_BASE_URL}/properties/${id}`,
    },
    listings: {
      list: `${API_BASE_URL}/listings`,
      create: `${API_BASE_URL}/listings`,
      update: (id: string) => `${API_BASE_URL}/listings/${id}`,
      delete: (id: string) => `${API_BASE_URL}/listings/${id}`,
    },
    inquiries: {
      list: `${API_BASE_URL}/inquiries`,
      details: (id: string) => `${API_BASE_URL}/inquiries/${id}`,
      update: (id: string) => `${API_BASE_URL}/inquiries/${id}`,
    },
    tenants: {
      list: `${API_BASE_URL}/tenants`,
      create: `${API_BASE_URL}/tenants`,
      update: (id: string) => `${API_BASE_URL}/tenants/${id}`,
      delete: (id: string) => `${API_BASE_URL}/tenants/${id}`,
    },
    reports: {
      generate: `${API_BASE_URL}/reports/generate`,
      list: `${API_BASE_URL}/reports`,
    },
  },
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
};

export default apiConfig;